module.exports = "/images/ve.svg?6f4737d8366c61f930dea3a1c00c86e4";